// extracted by mini-css-extract-plugin
module.exports = {"buttonWithoutPriceWrapper":"SticksFormSubmitButton_buttonWithoutPriceWrapper__rePaU","buttonWithPriceWrapper":"SticksFormSubmitButton_buttonWithPriceWrapper__v_lab"};